// Дефолтное наполнение шапки/футера. Единый источник: фолбэки Header/Footer
// и предзаполнение формы chrome при создании лэндинга в админке.

export const chromeDefaults = {
    brand_prefix: "ТТ",
    brand_accent: "Букинг",
    brand_subtitle: "Группа компаний «Турне-Транс»",
    brand_logo: "",
    brand_logo_footer: "",
    nav: [
        { label: "Услуги", anchor: "#services" },
        { label: "Технологии", anchor: "#partners" },
        { label: "Преимущества", anchor: "#advantages" },
        { label: "Контакты", anchor: "#contacts" },
    ],
    login_label: "Войти в кабинет",
    login_url: "https://www.ttbooking.ru/login/",
    demo_label: "Демо вход",
    demo_url: "https://www.ttbooking.ru/login/#demo",
    footer_description: "Группа компаний «Турне-Транс» — партнёрская программа для турагентств.",
    footer_company: [],
    footer_address: "",
    footer_phone: "",
    footer_email: "",
    footer_site_url: "",
    footer_site_label: "",
    footer_gds: [],
    footer_copyright: "",
    footer_privacy_url: "",
    footer_privacy_label: "Политика обработки персональных данных",
};
